import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import logoGif from '../logo.gif';

const TermsOfService = () => {
  return (
    <motion.div
      className="privacy-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <header className="privacy-header">
        <Link to="/" className="logo-link">
          <motion.img 
            src={logoGif} 
            alt="Folivana Music Logo"
            className="privacy-logo"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 400 }}
          />
          <h1>Folivana Music</h1>
        </Link>
      </header>

      <div className="privacy-container">
        <h1>Terms of Service for Folivana Music</h1>
        <p className="last-updated">Last updated: 19 Jan 2025</p>
        
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By using Folivana Music ("the Bot"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Bot.</p>
        </section>
        
        <section>
          <h2>2. Description of Service</h2>
          <p>Folivana Music is a Discord bot that provides music playback and related features within Discord servers. The Bot's functionality is subject to change without notice.</p>
        </section>
        
        <section>
          <h2>3. User Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Bot for any unlawful purpose or in violation of any Discord policies</li>
            <li>Attempt to gain unauthorized access to the Bot's systems or related infrastructure</li>
            <li>Use the Bot to distribute spam, malware, or other malicious content</li>
            <li>Interfere with or disrupt the integrity or performance of the Bot</li>
          </ul>
        </section>
        
        <section>
          <h2>4. Intellectual Property</h2>
          <p>All rights, title, and interest in and to the Bot, including all associated intellectual property rights, are and will remain with Folivana Music. You may not modify, adapt, or create derivative works based on the Bot without explicit permission.</p>
        </section>
        
        <section>
          <h2>5. Disclaimer of Warranties</h2>
          <p>The Bot is provided "as is" without warranty of any kind. We disclaim all warranties, express or implied, including but not limited to the implied warranties of merchantability and fitness for a particular purpose.</p>
        </section>
        
        <section>
          <h2>6. Limitation of Liability</h2>
          <p>In no event shall Folivana Music be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Bot.</p>
        </section>
        
        <section>
          <h2>7. Modifications to the Service</h2>
          <p>We reserve the right to modify or discontinue, temporarily or permanently, the Bot or any features or portions thereof without prior notice.</p>
        </section>
        
        <section>
          <h2>8. Termination</h2>
          <p>We may terminate or suspend your access to the Bot immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms of Service.</p>
        </section>
        
        <section>
          <h2>9. Governing Law</h2>
          <p>These Terms shall be governed and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions.</p>
        </section>
        
        <section>
          <h2>10. Changes to Terms</h2>
          <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. It is your responsibility to review these Terms periodically for changes.</p>
        </section>
        
        <section>
          <h2>11. Contact Us</h2>
          <p>If you have any questions about these Terms, please contact us at Support Server</p>
        </section>

        <div className="back-to-home">
          <Link to="/" className="back-button">
            ← Back to Home
          </Link>
        </div>
      </div>
      <motion.footer 
    className="footer"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, margin: "0px 0px -100px 0px" }}
    transition={{ duration: 0.6 }}
  >
    <div className="footer-content">
      <div className="footer-main">
        <div className="footer-logo">
          <motion.img 
            src={logoGif} 
            alt="Music Bot Logo"
            className="footer-logo-img"
            whileHover={{ scale: 1.1 }}
            transition={{ type: "spring", stiffness: 400 }}
            loading="lazy"
          />
          <h3>Folivana Music</h3>
        </div>

        <div className="footer-legal-links">
          <Link to="/PrivacyPolicy">Privacy Policy</Link>
          <span>•</span>
           <Link to="/tos">Terms of Service</Link>
         </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Folivana Music. All rights reserved.</p>
        <div className="footer-credits">
          <span>Made with ❤️ by just-Nixx</span>
        </div>
      </div>
    </div>
  </motion.footer>
    </motion.div>
  );
};

export default TermsOfService;





